import { useQuery, useMutation } from "react-query";
import {
  getHotelById,
  getHotels,
  getHotelList,
  updateHotelReview,
  getProjectHotelReports,
  replicateHotelReports,
} from "../api/hotel";
import { getHotelSubHeaderData } from "../api/project";

const useGetHotelById = (id, options = {}) =>
  useQuery(["getHotelById", id], () => getHotelById(id), options);

const useGetHotels = (options = {}) =>
  useQuery("getHotels", getHotels, options);

const useGetHotelList = (options = {}) =>
  useQuery("getHotels", getHotelList, options);

const useUpdateHotelReview = (options = {}) => {
  return useMutation(updateHotelReview, options);
};

// const useGetHotelReports = (id, options = {}) =>
//   useQuery(["getHotelReports", id], () => getHotelReports(id), {
//     enabled: !!id,
//     ...options,
//   });

const useGetProjectHotelReports = (project, hotel, options = {}) =>
  useQuery(
    ["getProjectHotelReports", project, hotel],
    () => getProjectHotelReports(project, hotel),
    {
      enabled: !!(project && hotel),
      ...options,
    },
  );

const useGetHotelSubHeaderData = (hotelId, projectId, options = {}) =>
  useQuery(
    ["getHotelSubHeaderData", hotelId, projectId],
    () => getHotelSubHeaderData(hotelId, projectId),
    options,
  );

const useReplicateHotelReports = (options = {}) =>
  useMutation(replicateHotelReports, options);

export {
  useGetHotelById,
  useGetHotels,
  useGetHotelList,
  useUpdateHotelReview,
  // useGetHotelReports,
  useGetProjectHotelReports,
  useGetHotelSubHeaderData,
  useReplicateHotelReports,
};
